import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

	transform(value: number | string): string {
		return value ? value.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ' ') : null
	}
}
